import { makeStyles } from '@material-ui/core/styles';
import { Colors } from '../../styles';

const useStyles = makeStyles((theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  header_actions: {
    color: Colors.APP_COLOR_HIGHLIGHT(),
    background: 'white',
    border: '1px solid white',
    marginLeft: '.5rem',
    '&:hover': {
      background: 'white',
    },
  },
  titleLayout: {
    padding: 20,
    backgroundColor: Colors.APP_COLOR_HIGHLIGHT(),
    color: 'white',
  },
  contentContainer: {
    padding: 12,
  },
  cardLayout: {
    marginBottom: 6,
    marginLeft: 12,
  },
  tableList: {
    marginTop: 12,
    marginBottom: 6,
  },
  dashboardButton: {
    //float: 'right',
    marginTop: 6,
    marginBottom: 6,
    marginRight: 12,
    //width: '99%',
  },
}));

export default useStyles;
